import { render, staticRenderFns } from "./StandardsFormats.vue?vue&type=template&id=39183762&"
import script from "./StandardsFormats.vue?vue&type=script&lang=js&"
export * from "./StandardsFormats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports